<template>
  <Modal
    :closable="false"
    footer-hide
    v-model="show"
    width="80">
    <div class="query">
      <Form label-position="top">
        <FormItem label="見出し">
          <Input
            v-model="channelMessage.text"
            placeholder="見出しを入力">
          </Input>
        </FormItem>
        <FormItem label="備考">
          <Input
            v-model="channelMessage.meta.note"
            placeholder="備考を入力">
          </Input>
        </FormItem>
        <FormItem label="参考リンク">
          <Input
            v-model="channelMessage.meta.ref"
            placeholder="参考リンク">
          </Input>
        </FormItem>
        <FormItem>
          <Button v-if="channelMessage.id" long @click="update(channelMessage.id)">メッセージを更新</Button>
          <Button v-else long @click="create">メッセージ追加</Button>
        </FormItem>
      </Form>
    </div>
  </Modal>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  data() {
    return {
      show: false,
      channelMessage: {
        text: null,
        meta: {}
      }
    }
  },
  watch: {
    target(val) {
      if (val) {
        this.show = true
        this.channelMessage = val
      } else {
        this.show = false
        this.resetChannelMessage()
      }
    },
    show(val) {
      if (!val) {
        this.unsetTarget()
      }
    },
  },
  computed: {
    ...mapGetters({
      target: 'dashboard/channelMessageModalTarget'
    }),
  },
  methods: {
    ...mapActions({
      unsetTarget: 'dashboard/unsetChannelMessageModalTarget',
      createChannelMessage: 'createChannelMessage',
      updateChannelMessage: 'updateChannelMessage',
    }),
    async create() {
      await this.createChannelMessage({
        channelId: this.$route.params.channelId,
        channelMessageInput: {
          text: this.channelMessage.text,
          meta: this.channelMessage.meta,
        }
      })
      this.show = false
    },
    async update(channelMessageId) {
      await this.updateChannelMessage({
        channelId: this.$route.params.channelId,
        channelMessageId: channelMessageId,
        channelMessageInput: {
          text: this.channelMessage.text,
          meta: this.channelMessage.meta,
        }
      })
      this.show = false
    },
    async resetChannelMessage() {
      this.channelMessage = {text: null, meta: {}}
    }
  }
}
</script>
